import './AccessStatisticsLegend.scss';

import classNames from 'classnames';
import React from 'react';
import { Tag } from 'antd';

import { DATA_SENSITIVITY_COLORS, DATA_SENSITIVITY_LABELS, DataSensitivityLevelId } from '@sonar-software/sonar-core';

export interface AccessStatisticsLegendProps {
	classifications?: Record<DataSensitivityLevelId, boolean>;
}

export const AccessStatisticsLegend : React.FC<AccessStatisticsLegendProps> = ({ classifications }) =>
	<div className='access-statistics-legend'>
		{
			Object.entries(DATA_SENSITIVITY_COLORS)
				.filter(([ id ]) => classifications?.[ Number(id) as DataSensitivityLevelId ])
				.map(
					([ id, color ]) =>
						<div
							className='legend-item'
							key={ id }>
							<Tag className={ classNames('color-bar', color) } />
							{ DATA_SENSITIVITY_LABELS[ Number(id) as DataSensitivityLevelId ] }
						</div>
				)
		}
	</div>;
